import { gql } from "@apollo/client";
import { imageType } from "../constants";

export const UPDATE_HOUSE_LOGO = gql`
  mutation UpdateHouseLogo($id: ID!, $files: [Upload!]!) {
    updateHouseLogo(id: $id, files: $files) {
      ${imageType}
    } 
  }
`;

export const UPDATE_ORGANIZATION_LOGO = gql`
  mutation UpdateOrganizationLogo($files: [Upload!]!) {
    updateOrganizationLogo(files: $files) {
      ${imageType}
    }
  }
`;

export const UPLOAD_JOB_FILES = gql`
  mutation UploadJobFiles($jobId: ID!, $type: JobType!, $files: [Upload!]!) {
    uploadJobFiles(jobId: $jobId, type: $type, files: $files) {
      ${imageType}
    }
  }
`;

export const UPLOAD_PRODUCT_FILE = gql`
  mutation UploadProductFile($id: ID!, $propertyId: String!, $files: [Upload!]!) {
    uploadProductFile(id: $id, propertyId: $propertyId, files: $files) {
      ${imageType}
    }
  }
`;